import styled from "@emotion/styled";
import { DownloadCloud } from "react-feather";
import { StyledPropsWithTheme } from "../../utils/globalTypes";

const DownloadLogo = styled(DownloadCloud)<StyledPropsWithTheme>`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Styled = { DownloadLogo };
